class TextWithBars extends HTMLElement {
  connectedCallback() {
    this.initObserver();
  }

  initObserver() {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.animateBars();
            this.animateCounters();
            obs.unobserve(this);
          }
        });
      },
      { threshold: 0.2 },
    );

    observer.observe(this);
  }

  animateBars() {
    this.querySelectorAll('.text-with-bars__bar').forEach((bar) => {
      const targetPercentage = bar.getAttribute('data-bar-percentage');
      bar.style.width = targetPercentage + '%';
    });
  }

  animateCounters() {
    this.querySelectorAll('[data-counter-value]').forEach((counter) => {
      const targetValue = +counter.getAttribute('data-counter-value');
      let current = 0;
      const increment = targetValue / 30;
      const interval = setInterval(() => {
        current += increment;
        if (current >= targetValue) {
          counter.textContent = targetValue;
          clearInterval(interval);
        } else {
          counter.textContent = Math.floor(current);
        }
      }, 30);
    });
  }
}
customElements.define('text-with-bars', TextWithBars);
